var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fileAvailable)?_c('el-link',{attrs:{"type":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.download($event)}}},[_vm._v("\n  "+_vm._s(_vm.name)+"\n")]):_c('span',[_vm._v("\n  "+_vm._s(_vm.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }